import { useQuery } from "@tanstack/react-query";
import { ToastService } from "@shared/lib/services";
import { useEffect } from "react";

import { BackednResponse } from "@shared/lib/types";
import { INFLUENCER_LIST_QUERY_KEY } from "../constants";
import {
  IInfluencerFacets,
  ILocationFacet,
} from "@shared/lib/types/influencer";
import { InfluencerService } from "../services/influencer.service";

export function useGetLocationFacets(location?: string) {
  const { data, isLoading, isError, error } = useQuery<
    BackednResponse<ILocationFacet[]>
  >({
    queryKey: [...INFLUENCER_LIST_QUERY_KEY, "facets", "location", location],
    queryFn: () => InfluencerService.getLocationFacets(location),
  });

  const errorMessage = isError && error?.message;

  useEffect(() => {
    if (errorMessage) {
      ToastService.error(errorMessage);
    }
  }, [errorMessage]);

  return {
    locationFacets: data?.data,
    isError,
    isFetching: isLoading,
  };
}
